import React, { useContext } from 'react';
import { useLocalStorage } from 'utils/useLocalStorage';

import FleetFiltersContext from 'modules/fleet/filters/context';

const JobReviewFiltersContext = React.createContext();

const jobReviewDefaultFilters = {};

function JobReviewFiltersContextProvider({ defaultFilters = jobReviewDefaultFilters, children }) {
  const { filters: fleetFilters } = useContext(FleetFiltersContext);
  const [filters, setFilters] = useLocalStorage('jobReview/filters', defaultFilters);

  const value = {
    filters: {
      ...fleetFilters,
      ...filters,
    },
    setFilters,
  };

  return (
    <JobReviewFiltersContext.Provider value={value}>
      {children(value)}
    </JobReviewFiltersContext.Provider>
  );
}

export default JobReviewFiltersContext;
export { jobReviewDefaultFilters, JobReviewFiltersContextProvider };
